import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth';
import { MEMBERSHIP } from '../../utils/membership';

/**
 * Gate für die Seiten, die nur die Leute angehen, die den Club machen:
 * Crew, Organisatoren und Admins.
 *
 * Erster Fall ist die Änderungsliste („Neuerungen"). Für ein Mitglied oder
 * einen Gast ist sie kein Gewinn - sie beschreibt Arbeit an der Seite, nicht
 * Termine.
 *
 * Mit `crewOnly` faellt die Orga-Rolle heraus - das braucht der Bereich
 * „Die Crew" (v0.28.0), fuer den allein die Zugehoerigkeit zaehlt.
 *
 * Wie OrganizerRoute reine UI-Bequemlichkeit und keine Sicherheitsgrenze.
 * Hier ist das unkritisch, weil die Seite nichts liest und nichts schreibt:
 * Ihr Inhalt steht im ausgelieferten Bundle. Dieselbe Regel wie dort gilt
 * trotzdem - die Zugehörigkeit steckt im Profil-Dokument, nicht im Token,
 * also muss das Gate hinter dem Ladezustand sitzen. Ohne das wäre
 * `membership` beim ersten Render noch nicht da und die Crew flöge heraus.
 */
export default function CrewRoute({ children, crewOnly = false }) {
  const { user, loading, isAdmin, isOrganizer, isActiveMember, membership } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="mt-loading">
        <div className="mt-spinner" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // `crewOnly` laesst die Orga-Rolle NICHT mehr durch (v0.28.0): Fuer den
  // Bereich „Die Crew" zaehlt allein die Zugehoerigkeit, und ein Organisator
  // kann der Zugehoerigkeit nach Mitglied sein. Die Aenderungsliste bleibt
  // beim weiten Kreis - sie beschreibt Arbeit an der Seite, die einen
  // Organisator sehr wohl angeht.
  const allowed = crewOnly
    ? isAdmin || (isActiveMember && membership === MEMBERSHIP.CREW)
    : isAdmin || isOrganizer || (isActiveMember && membership === MEMBERSHIP.CREW);
  if (!allowed) {
    return <Navigate to="/intern" replace />;
  }

  return children;
}
